import React, { useState, useRef, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import TERMS_AUTOCOMPLETE from '../queries/autocomplete';

const useTermsAutocomplete = () => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getAutocomplete] = useLazyQuery(TERMS_AUTOCOMPLETE);
  const debounceTimer = useRef(null);

  useEffect(() => () => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
  }, []);

  const handleSearchChange = async (e, { value }, onValueChange) => {
    if (onValueChange) {
      onValueChange(value);
    }

    // Clear existing timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (value.length < 2) {
      setResults([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    // Debounce the API call
    debounceTimer.current = setTimeout(async () => {
      try {
        const { data } = await getAutocomplete({ variables: { query: value } });
        if (data?.termsAutocomplete) {
          setResults(
            data.termsAutocomplete.map((item) => {
              const highlightStripped = item.highlight ? item.highlight.replace(/<[^>]*>/g, '') : '';
              const isTermMatch = highlightStripped === item.term;
              return {
                title: isTermMatch && item.highlight ? item.highlight : item.term,
                description: !isTermMatch && item.highlight ? `(${item.highlight})` : '',
              };
            }),
          );
        }
      } catch (error) {
        // Silently handle autocomplete errors
      } finally {
        setIsLoading(false);
      }
    }, 300);
  };

  const resultRenderer = ({ title, description }) => (
    <div>
      {/* eslint-disable-next-line react/no-danger */}
      <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
      {description && (
        /* eslint-disable-next-line react/no-danger */
        <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </div>
  );

  return {
    results,
    isLoading,
    handleSearchChange,
    resultRenderer,
  };
};

export default useTermsAutocomplete;
